export const AllWarnings = [
    {
        id: "0f2f9333-b8c3-4c08-9761-7dbfc3b725a5",
        title: "Gas narcosis ",
        description:
            "High risk of gas narcosis resulting in impairment of motor skills and judgement at some depths. Trimix should be considered.",
        group: "Diving",
        level: "Danger",
        createdAt: "2024-10-03T12:25:14.432Z",
        updatedAt: "2024-10-03T13:01:00.068Z",
    },
    {
        id: "cf8ea60e-a361-455a-a2c1-5b0997befd35",
        title: "Standard air (21% oxygen) is unsafe",
        description:
            "Normal air is not safe to breath at some depths. Specialist training is required.",
        group: "Diving",
        level: "Danger",
        createdAt: "2024-10-03T12:13:21.739Z",
        updatedAt: "2024-10-03T12:23:32.331Z",
    },
    {
        id: "16993749-0efc-4b06-acb0-64f62b50c2f3",
        title: "No mobile reception",
        description:
            "The area is remote and does not have mobile reception so you need to plan accordingly",
        group: "General",
        level: "Warning",
        createdAt: "2023-08-22T10:19:15.011Z",
        updatedAt: "2023-08-27T11:10:12.013Z",
    },
    {
        id: "2f18629a-44f8-4367-831c-79ecd2ebc610",
        title: "Strong current",
        description:
            "The site has potential for strong currents and care must be taken to account for them if diving during non slack water.",
        group: "Diving",
        level: "Danger",
        createdAt: "2024-10-04T02:09:52.730Z",
        updatedAt: "2024-10-04T02:09:52.730Z",
    },
    {
        id: "cc7f29e0-e14e-4e6f-b478-6cf40843a8ae",
        title: "Cave environment",
        description:
            "Cave diving requires specific training and diving caves without this training can easily result in death",
        group: "Diving",
        level: "Danger",
        createdAt: "2024-10-03T11:40:26.721Z",
        updatedAt: "2024-10-03T11:40:26.721Z",
    },
    {
        id: "b187d40e-6c36-4790-8069-85f5e841dd97",
        title: "Fishing lines",
        description:
            "Fishing is commonly done around the site so care must be taken to avoid hooks and lines that could entangle you.",
        group: "Diving",
        level: "Warning",
        createdAt: "2024-10-04T08:21:20.388Z",
        updatedAt: "2024-10-04T08:21:20.388Z",
    },
    {
        id: "03a37af4-9cb0-489e-b25b-65abef3e84c6",
        title: "Overhead environment",
        description: "Diving in overhead environments requires specialist diving training",
        group: "Diving",
        level: "Danger",
        createdAt: "2023-08-22T09:54:22.631Z",
        updatedAt: "2024-10-03T11:39:16.231Z",
    },
    {
        id: "c2387bb7-39d4-4b81-b5a7-53a8da5440fd",
        title: "Boat traffic",
        description: "Boats may be present in the area and care must be taken surfacing. ",
        group: "Diving",
        level: "Warning",
        createdAt: "2024-10-04T08:20:30.024Z",
        updatedAt: "2024-10-04T08:20:30.024Z",
    },
    {
        id: "a35c6357-a302-42da-9460-61a8455fda48",
        title: "Heavy silt",
        description: "Potential for high levels of silt and zero visibility on exit",
        group: "Diving",
        level: "Warning",
        createdAt: "2023-08-27T11:44:44.183Z",
        updatedAt: "2023-08-27T11:44:44.183Z",
    },
    {
        id: "8b0aa684-da2a-4269-8b0a-e8b330d119d5",
        title: "Hydrogen Sulfide gas maybe present",
        description:
            "Hydrogen sulfide has a characteristic rotten egg smell which can be detected at very low levels, well below those that are known to cause health effects.  Smelling hydrogen sulfide does not mean that it will harm your health.",
        group: "Caving",
        level: "Danger",
        createdAt: "2023-12-07T23:06:43.000Z",
        updatedAt: "2023-12-07T23:06:43.000Z",
    },
    {
        id: "5c7bd52d-6202-4270-969d-1e7a6a1b0668",
        title: "Carbon dioxide gas maybe present",
        description:
            "Symptoms of mild CO2 exposure may include headache and drowsiness. At higher levels,rapid  breathing, confusion, increased cardiac output, elevated blood pressure and increased  arrhythmias may occur.",
        group: "Caving",
        level: "Danger",
        createdAt: "2023-12-07T23:09:33.341Z",
        updatedAt: "2023-12-07T23:09:33.341Z",
    },
    {
        id: "1772a346-665a-4bad-87ab-4e523ec3d7ea",
        title: "Unstable ",
        description: "The cave is unstable and great care must be taken",
        group: "Caving",
        level: "Danger",
        createdAt: "2023-12-27T09:58:17.664Z",
        updatedAt: "2023-12-27T09:58:17.664Z",
    },
    {
        id: "21cad796-7ca7-453c-ba4d-7acfc0c5b501",
        title: "Extremely dangerous",
        description: "Do not attempt to dive this site, it can be deadly.",
        group: "Diving",
        level: "Danger",
        createdAt: "2023-11-11T00:57:29.923Z",
        updatedAt: "2023-11-11T00:58:36.670Z",
    },
    {
        id: "ac425409-9aae-4833-a681-d664bff2329e",
        title: "Tight restrictions",
        description:
            "Place may have tight restrictions that are unsuitable for certain equipment configurations",
        group: "Diving",
        level: "Warning",
        createdAt: "2023-08-27T11:45:29.296Z",
        updatedAt: "2023-08-27T11:45:29.296Z",
    },
    {
        id: "1b13c7e4-dc55-41e0-b297-7fbf2deded5e",
        title: "Permit required",
        description: "A permit is required to access this location",
        group: "General",
        level: "Info",
        createdAt: "2024-10-08T22:49:34.755Z",
        updatedAt: "2024-10-08T22:49:34.755Z",
    },
    {
        id: "5b3a6db0-c361-42b6-b19b-3849a25afd48",
        title: "Remote location",
        description: "The place is a significant distance from emergency services",
        group: "General",
        level: "Warning",
        createdAt: "2023-08-22T10:20:11.773Z",
        updatedAt: "2023-08-27T11:10:27.111Z",
    },
    {
        id: "8553d059-d8f5-4a2c-a45d-730714b7868e",
        title: "Penetration not permitted",
        description: "It is not permitted to enter this wreck",
        group: "Diving",
        level: "Info",
        createdAt: "2024-11-27T09:37:59.837Z",
        updatedAt: "2024-11-27T09:37:59.837Z",
    },
];

let warningMap: Map<string, any> | undefined;

export function getWarning(id: string) {
    if (!warningMap) {
        warningMap = new Map<string, any>();
        for (const w of AllWarnings) {
            warningMap.set(w.id, w);
        }
    }
    if (warningMap.has(id)) {
        return warningMap.get(id);
    }
    return undefined;
}
